<template>
  <section id="purple-header" class="w-100 bg-purple-header">
    <b-container fluid class="container-purple-header d-flex justify-content-end px-3">
      <div class="d-flex py-2">
        <router-link
          class="text-uppercase py-2 px-3 text-purple-header"
          v-for="m in menu"
          :key="m.id"
          :to="m.pathTo"
          v-html="m.title"
          v-show="m.title !== 'quero vender meu veículo'"
        />
      </div>
      <a
        href="https://blog.vaapty.com/"
        class="text-uppercase py-2 px-3 text-purple-header d-flex align-items-center"
        target="_blank"
      >Blog</a>
      <router-link
        to="/vender-meu-carro"
        class="text-uppercase ml-2 px-4 text-purple-header bg-white d-flex align-items-center"
      >quero vender meu veículo</router-link>
    </b-container>
  </section>
</template>

<script>
export default {
  name: "purple-header",
  data: () => ({
    menu: [
      {
        title: "quem somos",
        pathTo: "/quem-somos",
        disabled: false,
        styleButton: "",
      },
      {
        title: "como funciona",
        pathTo: "/como-funciona",
        disabled: false,
        styleButton: "",
      },
      {
        title: "seja um franqueado",
        pathTo: "/seja-um-franqueado",
        disabled: false,
        styleButton: "",
      },
      {
        title: "perguntas frequentes",
        pathTo: "/perguntas-frequentes",
        disabled: false,
        styleButton: "",
      },
      {
        title: "contato",
        pathTo: "/contato",
        disabled: false,
        styleButton: "",
      },
      {
        title: "sou lojista",
        pathTo: "/sou-lojista",
        disabled: true,
        styleButton: "",
      },
      {
        title: "quero vender meu veículo",
        pathTo: "/vender-meu-carro",
        disabled: true,
        styleButton: "",
      },
    ],
  }),
};
</script>

<style lang="scss" scoped>
$break-point-menu: "991px";

#purple-header {
  @media screen and (max-width: #{$break-point-menu}) {
    display: none !important;
  }
}

.container-purple-header {
  font-size: 80%;
}

.bg-purple-header {
  background-color: #ebebeb;
}

.text-purple-header {
  color: #696969;
}
</style>